module.exports = {
      id: "lifestyle-usage",
      viewBox: "0 0 24.217 32.155",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#lifestyle",
      toString: function () {
        return this.url;
      }
    }